"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPnlPrecision = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
/**
 * 获取精度位数：
 * - 当数字绝对值小于 1 时：保留 4 位有效小数（精度最长不超过 12 位）
 * - 当数字大于等于 1 时：返回传入的 precision
 * @param value number | string
 * @param precision number
 * @returns number
 */
const getPnlPrecision = (value, precision) => {
    const valueD = new trade_utils_lib_1.SafeDecimal(value);
    if (valueD.abs().lt(1)) {
        // sd (significant digits): 有效数字的位数
        const sd = valueD.sd();
        // dp (decimal places): 小数点后的位数
        const dp = valueD.dp();
        if (dp > 0) {
            // 最多保留 4 位有效小数
            const autoPrecision = dp - sd + 4;
            // 最高 12 位精度
            return Math.min(autoPrecision, 12);
        }
    }
    return precision;
};
exports.getPnlPrecision = getPnlPrecision;
